import { CANADIAN_PROVINCES, US_STATES } from "../constants/locationConstants";

export const filterByLocation = (clients = [], address = {}) => {
  const userCountry = address.country?.trim() || null;
  const userProvince = address.province?.trim().toUpperCase() || null;
  const userCity = address.city?.trim().toLowerCase() || null;
  const userPostal = address.postalCode?.trim().toUpperCase() || null;

  const filtered = clients.filter((c) => {
    const cProv = c.province ? c.province.trim().toUpperCase() : null;
    const cCity = c.city ? c.city.trim().toLowerCase() : null;
    const cPostal = c.postalCode ? c.postalCode.trim().toUpperCase() : null;

    // Infer country
    let inferredCountry = null;
    if (cProv && CANADIAN_PROVINCES.includes(cProv)) inferredCountry = "Canada";
    else if (cProv && US_STATES.includes(cProv)) inferredCountry = "USA";

    console.log(`🌍 Client: ${c.directoryName} | Prov: ${cProv} | Inferred Country: ${inferredCountry}`);

    // Exclude null-province when filtering by country
    if (userCountry && !inferredCountry) return false;

    // Country filter
    if (userCountry && inferredCountry && inferredCountry !== userCountry) return false;

    // Province filter
    if (userProvince && cProv && cProv !== userProvince) return false;

    // City filter
    if (userCity && cCity && !cCity.includes(userCity)) return false;

    // Postal filter
    if (userPostal && cPostal) {
      if (userPostal.substring(0, 3) !== cPostal.substring(0, 3)) return false;
    }

    return true;
  });

  // 🔍 Show FINAL output after filtering
  console.log("🏁 FINAL FILTERED RESULT:", filtered.map((f) => ({
    name: f.directoryName,
    prov: f.province,
    country: address.country
  })));

  return filtered;
};
